import { render, staticRenderFns } from "./AttendeeEditTabAccount.vue?vue&type=template&id=61afffb7&"
import script from "./AttendeeEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./AttendeeEditTabAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports